import React, { useEffect, useState } from 'react';
import {
  Affix,
} from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Box,
  Flex, ForEach,
} from '../components';
import CustomAction from './CustomAction';
import TextAction from './TextAction';
import DropDownAction from './DropDownAction';
import { LEFT_SIDEBAR_WIDTH_AND_MARGIN } from '../../../state/actions/constants/app.constants';

export const NAVIGATION_ANCHOR = 'appNavigation';
export default function ActionsHeader(props) {
  const onHoverStyle = `
    .actionLink:hover {
      color: #049BDD !important;
    }
  `;
  const [rect, setRect] = useState(0);
  const [dinamicSpace, setDinamicspace] = useState(0);
  const [contentStart, setContentStart] = useState(0);

  useEffect(() => {
    document.getElementById('scrollableDiv').addEventListener('scroll', () => {
      const pageContentRect = document.getElementById('page-content')?.getBoundingClientRect();
      const pageRect = document.getElementById('page')?.getBoundingClientRect();

      setDinamicspace(pageRect ? pageRect.width - pageContentRect.width : 0);
      setContentStart(pageContentRect ? pageContentRect.x : 0);
    });
    document.getRootNode().addEventListener('scroll', () => {
      const rect = document.getElementById('sidebar').getBoundingClientRect();
      const pageContentRect = document.getElementById('page-content')?.getBoundingClientRect();
      const pageRect = document.getElementById('page')?.getBoundingClientRect();

      setRect(rect.x);
      setDinamicspace(pageRect ? pageRect.width - pageContentRect.width : 0);
      setContentStart(pageContentRect ? pageContentRect.x : 0);
    });
    window.addEventListener('resize', () => {
      const pageContentRect = document.getElementById('page-content')?.getBoundingClientRect();
      const pageRect = document.getElementById('page')?.getBoundingClientRect();
      setDinamicspace(pageRect ? pageRect.width - pageContentRect.width : 0);
      setContentStart(pageContentRect ? pageContentRect.x : 0);
    });
  },
  []);
  // const pageContentRect = document.getElementById('page-content')?.getBoundingClientRect();
  //  const pageContentstart = !pageContentRect ? LEFT_SIDEBAR_WIDTH_AND_MARGIN : contentStart;
  const pageContentstart = contentStart;
  const appNavigation = useSelector(state => state.app.navigation);
  const {
    data, sticky, offsetTop, top, anchor,
  } = props;
  const initData = (e, i) => {
    const returnData = { ...e };
    if (!e.icon) returnData.icon = null;
    if (!e.text) returnData.text = null;
    if (!e.translationId) returnData.translationId = null;
    if (!e.component) returnData.component = null;
    if (!e.position) returnData.position = 'left';
    if (!e.priority) returnData.priority = i + 100;
    if (!e.onClick) returnData.onClick = () => {};
    if (!e.open) returnData.isOpen = false;
    if (!e.children) returnData.children = null;
    return returnData;
  };
  const linksData = data.map((e, i) => {
    if (Array.isArray(e)) return e.map((ee, ii) => initData(ee, ii));
    return initData(e, i);
  }).sort((a, b) => a.priority - b.priority);

  const rightLinks = linksData.filter(e => e.position === 'right');
  const leftLinks = linksData.filter(e => e.position !== 'right');
  const renderLink = (data, iteration, length, showDividerAlways = false) => {
    if (data.visible === false) return <></>;
    const isComponent = React.isValidElement(data.component);
    if (data.children) {
      return <DropDownAction data={data} iteration={iteration} length={length} />;
    }
    return isComponent
      ? <CustomAction component={data.component} iteration={iteration} length={length} showDividerAlways={showDividerAlways} />
      : <TextAction translationId={data.translationId} text={data.text} icon={data.icon} onClick={data.onClick} iteration={iteration} length={length} showDividerAlways={showDividerAlways} />;
  };
  let top_total = top;
  let offsetTop_total = offsetTop;
  if (anchor === NAVIGATION_ANCHOR) {
    top_total += appNavigation.hidden ? 0 : appNavigation.hiddenHeight;
    offsetTop_total = 64;
  }

  const content = (
    <Box p="16px 0" bg="#f0f2f5" style={false ? { position: 'sticky', top: '128px', zIndex: 1000 } : {}}>
      <Flex border="1px solid #DADCE0" borderRadius="2px" justifyContent="space-between" p="8px 0">
        <style>{onHoverStyle}</style>
        <Flex alignItems="baseline">
          <ForEach
            key="links-left"
            items={leftLinks}
            render={(data, i) => renderLink(data, i, leftLinks.length, rightLinks.length > 0)}
          />
        </Flex>
        <Flex alignItems="baseline">
          <ForEach
            key="links-right"
            items={rightLinks}
            render={(data, i) => renderLink(data, i, rightLinks.length)}
          />
        </Flex>
      </Flex>
    </Box>
  );
  return sticky ? (
    <div className="special-ant-affix">
      <style>
        {`.special-ant-affix div .ant-affix {transition: top 0.3s; top: ${offsetTop_total + top_total}px !important; left: ${pageContentstart + 24}px !important;}`}
      </style>
      <Affix offsetTop={offsetTop_total} target={() => document.getElementById('scrollableDiv')}>
        {content}
      </Affix>
    </div>
  ) : content;
}
const ActionType = PropTypes.shape({
  translationId: PropTypes.string,
  text: PropTypes.string,
  priority: PropTypes.number,
  position: PropTypes.string,
  icon: PropTypes.shape({}),
  component: PropTypes.object,
});
ActionsHeader.propTypes = {
  data: PropTypes.arrayOf(PropTypes.oneOfType([
    ActionType,
    PropTypes.arrayOf(ActionType),
  ])).isRequired,
  sticky: PropTypes.bool,
  offsetTop: PropTypes.number,
  top: PropTypes.number,
  anchor: PropTypes.string,
};
ActionsHeader.defaultProps = {
  sticky: true,
  offsetTop: 112,
  top: 0,
  anchor: false,
};
